<template>
    <b-row v-if="itensSelecionados && rateios">
        <b-col>
            <app-box titulo="Total a ser rateado">{{
                valorASerRateado | currency
            }}</app-box>
        </b-col>
        <b-col>
            <app-box
                titulo="Total disponível para ratear"
                :corBox="corBox"
                :corTexto="corTexto"
                >{{ valorDisponivel | currency }}</app-box
            >
        </b-col>
        <b-col>
            <app-box
                titulo="Total rateado"
                :corBox="corBox"
                :corTexto="corTexto"
                >{{ valorRateado | currency }} |
                {{
                    percentualRateado
                        | currency({
                            symbol: '%',
                            thousandsSeparator: '.',
                            fractionCount: 2,
                            fractionSeparator: ',',
                            symbolPosition: 'back',
                            symbolSpacing: false
                        })
                }}</app-box
            >
        </b-col>
    </b-row>
</template>

<script>
export default {
    props: {
        itensSelecionados: {
            type: Array
        },

        rateios: {
            type: Array
        },

        valorASerRateado: {
            type: Number
        },

        valorRateado: {
            type: Number
        },

        valorDisponivel: {
            type: Number
        },

        percentualRateado: {
            type: Number
        }
    },

    computed: {
        corTexto() {
            return this.percentualRateado < 100 ? 'danger' : 'primary'
        },

        corBox() {
            return this.percentualRateado < 100 ? 'danger' : 'primary'
        }
    }
}
</script>